import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "development",
  sendDefaultPii: false,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || 0.1),
  replaysSessionSampleRate: (() => {
    const env = import.meta.env.VITE_SENTRY_ENVIRONMENT || "development";
    const configured = import.meta.env.VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE;
    if (configured !== undefined && configured !== "") return Number(configured);
    return env === "production" ? 0.05 : 0;
  })(),
  replaysOnErrorSampleRate: (() => {
    const configured = import.meta.env.VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE;
    if (configured !== undefined && configured !== "") return Number(configured);
    return 1.0;
  })(),
});

createRoot(document.getElementById("root")!).render(<App />);
